import { queryOptions } from "@tanstack/react-query"
import { client } from "./client"

export type PublicTenantSettings = {
  allowedFileExtensions: string
}

export const tenantSettingsKeys = {
  all: ["tenantSettings"] as const,
  public: () => [...tenantSettingsKeys.all, "public"] as const,
}

const getPublicTenantSettings = async (): Promise<PublicTenantSettings> => {
  const { data } = await client.axiosInstance.get("/api/TenantSetting/GetPublicInformation")
  return data
}

export const getPublicTenantSettingsQuery = () =>
  queryOptions({
    queryKey: tenantSettingsKeys.public(),
    queryFn: getPublicTenantSettings,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours — rarely changes, no need to refetch often
    gcTime: 1000 * 60 * 60 * 24,
  })
